import { createAction, createSlice } from "@reduxjs/toolkit";

const submitReviewCourseSlice = createSlice({
  name: "submitReviewCourse",
  initialState: { hasError: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      state.hasError = null;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      state.hasError = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      state.hasError = true;
      /* TODO: reducer for failure*/
    },
    resetError(state) {
      state.hasError = null;
    },
  },
});

const { name, actions, reducer } = submitReviewCourseSlice;
const submitReviewCourseAction = createAction(name);

export {
  submitReviewCourseAction,
  actions as submitReviewCourseActions,
  reducer as submitReviewCourseReducer,
};
